/**
 * Utility functions for attachment handling
 */

/**
 * Generate a secure download URL for an attachment that goes through the backend proxy.
 * This ensures only authenticated users can access attachments and enforces document ownership.
 * 
 * @param attachment - Object with gcsObjectName and filename properties
 * @param base64 - The angular-utf8-base64 service instance
 * @param applicationId - Optional application ID for ownership verification (required for students)
 * @returns The secure download URL
 */
export function getSecureDownloadUrl(
    attachment: { gcsObjectName?: string; filename?: string; contentType?: string },
    base64: any,
    applicationId?: string
): string {
    if (!attachment || !attachment.gcsObjectName) {
        return "";
    }
    // Encode JSON with mediaLink, filename, contentType, and applicationId for secure access
    const payload = JSON.stringify({
        mediaLink: attachment.gcsObjectName,
        filename: attachment.filename || "attachment",
        contentType: attachment.contentType || "",
        applicationId: applicationId || ""
    });
    const encodedObjectId = base64.urlencode(payload);
    return `/api/attachment/download/${encodedObjectId}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/utils/attachment-utils.ts